import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import { trackPage } from './analytics-helper';

function ppSacCustomOptions(contactInfo, formFields, isFinalIntent, chatParams = {}, nativeParamsInfo) {
  let phoneType;
  let hoursOfOperation;

  if (!_isEmpty(chatParams) && chatParams.chatbot && chatParams.topic_key) {
    phoneType = chatParams.topic_key;
    hoursOfOperation = `${chatParams.topic_key}_HOURS_OF_OPERATIONS`;
    // Call Us Page logic when the request is from native experience.
  } else if (nativeParamsInfo && nativeParamsInfo.isNative) {
    phoneType = nativeParamsInfo.sacCustomKey;
    hoursOfOperation = phoneType && `${phoneType}_HOURS_OF_OPERATIONS`;
  } else {
    // finding index for customphone in form fields
    const customPhoneIndex = _findIndex(formFields, { type: 'customphone' });

    // customphone formfields label for desktop and default_text for venice
    const phoneDetails =
      formFields &&
      formFields[customPhoneIndex] &&
      (formFields[customPhoneIndex].label || formFields[customPhoneIndex].default_text);

    // Fetching the phone number and hours of operation value if exists
    phoneType = phoneDetails && phoneDetails[0] && phoneDetails[0].phone_type;
    hoursOfOperation = phoneType && `${phoneType}_HOURS_OF_OPERATIONS`;
  }

  // if custom options are not available return null
  if (!phoneType || !hoursOfOperation) {
    return null;
  }

  const customNumbers = contactInfo && contactInfo.ppSACNumbers;

  // finding index for phonetype
  const phoneIndex = _findIndex(customNumbers, { phone_type: phoneType });

  // finding index for HOO
  const HOOIndex = _findIndex(customNumbers, { phone_type: hoursOfOperation });

  // value for custom option phonetype
  const sacPhoneValue = customNumbers && customNumbers[phoneIndex] && customNumbers[phoneIndex].phone_value;

  // value for custom option HOO
  const sacCustomHOO = customNumbers && customNumbers[HOOIndex] && customNumbers[HOOIndex].phone_value;

  /**
   * if user is in final intent and issaccustomoptions Remote Config is enabled and
   * customphone phone number, hours of operations value exists
   * take the response from callus API
   */
  if (
    !_isEmpty(chatParams) &&
    typeof chatParams === 'object' &&
    chatParams.chatbot &&
    chatParams.chatbot !== 'undefined' &&
    phoneIndex < 0
  ) {
    trackPage({ id: 'callPageInvalidTopicCode', link: `InvalidCustomKey|${chatParams.topic_key}` });
  }

  if (
    (isFinalIntent && sacPhoneValue && sacCustomHOO) ||
    (!_isEmpty(chatParams) && chatParams.chatbot && chatParams.chatbot !== 'undefined' && phoneIndex >= 0)
  ) {
    return { phoneValue: sacPhoneValue, HoursOfOperation: sacCustomHOO };
  }

  // Call Us Page logic when the request is from native experience.
  // If Url params include native params
  if (!_isEmpty(nativeParamsInfo) && nativeParamsInfo.isNative && sacPhoneValue && sacCustomHOO) {
    return { phoneValue: sacPhoneValue, HoursOfOperation: sacCustomHOO };
  }
  return null;
}

export default ppSacCustomOptions;
